import cookies from 'js-cookie';

import { getGlobalArgs } from '@/root/global';
import { Theme } from '@/types/theme';
import { equals } from '@/utils/common';

import { themeMap } from './constants';

// TODO: удалить постфикс _docs, когда темная тема будет готова
const STORAGE_KEY_SELECTED_THEME = 'selected-theme_docs';

export const getInitialTheme = (): { theme: Theme; themeClassName: string } => {
  const theme = (cookies.get(STORAGE_KEY_SELECTED_THEME) as Theme) || Theme.Light;

  return {
    theme,
    themeClassName: themeMap[theme],
  };
};

export const updateTheme = (nextTheme: Theme) => {
  const isLocalhost = equals(getGlobalArgs('NEXT_PUBLIC_ENV', 'local'), 'local');

  cookies.set(STORAGE_KEY_SELECTED_THEME, nextTheme, {
    path: '/',
    domain: isLocalhost ? 'localhost' : '.cloud.ru',
    expires: 3650,
  });
};
